import { FormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class DirtyInvalidErrorStateMatcher<T> implements ErrorStateMatcher {
  isErrorState(control: FormControl<T> | null): boolean {
    return !!control?.invalid && control.dirty;
  }
}
